<ng-template
    *ngIf="propertyViewModel?.securityAccess == null; then baseComponent else securityComponent">
</ng-template>

<ng-template #baseComponent>
    <nts-base-file-upload-box
        #baseFileUploadBox
        [fileName]="initialValue != null ? initialValue : propertyViewModel.value$ | async"
        [tabIndex]="tabIndex"
        [accept]="propertyViewModel?.accept$ | async"
        [showErrorTooltip]="showErrorTooltip"
        [showErrorBorder]="showErrorBorder"
        [errorList]="propertyViewModel?.errors$ | async"
        [isDisabled]="isDisabled || (!(propertyViewModel.isEnabled$ | async))"
        [defaultBorderColor]="propertyViewModel.defaultColor"
        [activeBorderColor]="propertyViewModel.activeColor"
        [hoverBorderColor]="propertyViewModel.hoverColor"
        [validateFileFunc]="propertyViewModel.validateFileFunc"
        [uploadFileFunc]="propertyViewModel.uploadFileFunc"
        [addFileText]="propertyViewModel.addFileText$ | async"
        [removeFileText]="propertyViewModel.removeFileText$ | async"
        [processMode]="propertyViewModel.processMode"
        [isReadonly]="isDisabled || (!(propertyViewModel.isEnabled$ | async))"
        [placeholder]="placeholder"
        [attr.data-property-name]="propertyViewModel.propertyName"
        (onBlur)="onBlur($event)"
        (onFileChange)="modelChange($event)"
        (onProcessResultChange)="propertyViewModel.processResult$.next($event)">
    </nts-base-file-upload-box>
</ng-template>

<ng-template #securityComponent>
    <nts-base-security-text-box
        #baseSecurityTextBox
        [accessMode]="propertyViewModel.securityAccess"
        [value]="propertyViewModel.formattedValue$ | async">
    </nts-base-security-text-box>
</ng-template>
